<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';
    import constants from './../../constants.js';

    export default {
        mixins: [mixin],
        props: {
            imageSets: {
                type: Array,
                required: true,
            },
            mode: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                constants: constants,
            };
        },
        // Retrieve width and height from first image in set for reducing cumulative layout shift.
        // Ideally, these values come from the API in the future.
        computed: {
            imageSet() {
                if (!this.imageSets.length) return null;
                let imageSetByAlias = this.mode ? this.imageSets.find(set => this.parseImageAlias(set.alias).includes(this.mode)) : null;
                let imageSet = imageSetByAlias ? imageSetByAlias : this.imageSets[0];
                return imageSet;
            },
            images() {
                if (!this.imageSet) return [];
                return this.imageSet.images;
            },
            firstImage() {
                if (!this.images.length) return null;
                return this.images[0];
            },
        },
        methods: {
            parseImageAlias(alias) {
                if (!alias) return '';
                return alias.replace('Image_', '').toLowerCase();
            },
            // Simple media query transformer.
            toMediaQuery(mediaString) {
                if (!mediaString) return '';
                return mediaString.split('"')[1];
            },
        },
    
    };
</script>

<template>
    <picture v-if="imageSet && images.length && firstImage" 
             class="image is-clipped">
        <template v-for="(source, index) in images" 
                  :key="index">
            <source
                type="image/webp"
                :srcset="source.webPUrl"
                :sizes="source.displayWidth + 'px'"
                :media="toMediaQuery(source.mediaQuery)" />
        </template>
        <img :src="firstImage.defaultCropUrlWebp"
             :alt="imageSet.imageAlt"
             :width="firstImage.displayWidth"
             :height="firstImage.displayHeight"
             loading="lazy"
             onerror="this.onerror=null; this.style.backgroundColor='#cccccc'" />
    </picture>
</template>
